/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Err_Type_MissingInputs */

const en_sch_err_type_missing = /** @type {(inputs: Sch_Err_Type_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One of the types no longer exists. Reload the page and try again.`)
};

const de_sch_err_type_missing = /** @type {(inputs: Sch_Err_Type_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einer der Typen existiert nicht mehr. Lade die Seite neu und versuche es erneut.`)
};

/**
* | output |
* | --- |
* | "One of the types no longer exists. Reload the page and try again." |
*
* @param {Sch_Err_Type_MissingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_err_type_missing = /** @type {((inputs?: Sch_Err_Type_MissingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Err_Type_MissingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_err_type_missing(inputs)
	return en_sch_err_type_missing(inputs)
});